var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contents"},[_c('admin',{attrs:{"adminType":"staff","id":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }